import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { LiveNotificationRecord } from '@src/models/notifications/types'
import { liveNotificationsSelector } from '@src/selectors/notifications'
import { NotificationEngineScreen } from '@src/types'

interface UseLiveNotificationsOptions {
  screen: NotificationEngineScreen
}

export const useLiveNotifications = ({ screen }: UseLiveNotificationsOptions) => {
  const liveNotifications = useSelector(liveNotificationsSelector)

  return useMemo<LiveNotificationRecord[]>(
    () => liveNotifications.filter((liveNotification) => liveNotification.screen === screen),
    [liveNotifications, screen],
  )
}
